import type { DateRange } from "react-day-picker";
import type { TenantCdrsResponse } from "@/hooks/queries/use-tenant-cdrs-query";

export const CDR_EXPORT_PAGE_SIZE = 200;

type CdrData = TenantCdrsResponse["data"];

function startOfDay(date: Date) {
	const next = new Date(date);
	next.setHours(0, 0, 0, 0);
	return next;
}

function endOfDay(date: Date) {
	const next = new Date(date);
	next.setHours(23, 59, 59, 999);
	return next;
}

export function getDateRangeBounds(range: DateRange | undefined) {
	const from = range?.from ? startOfDay(range.from) : undefined;
	const to = range?.to ? endOfDay(range.to) : undefined;
	return { from, to };
}

export function filterByDateRange(
	records: CdrData,
	range: DateRange | undefined,
) {
	const { from, to } = getDateRangeBounds(range);

	if (!(from && to)) {
		return records;
	}

	return records.filter((record) => {
		if (!record.startStamp) {
			return false;
		}

		const callDate = new Date(record.startStamp);
		return callDate >= from && callDate <= to;
	});
}

export function getExportDateParams(range: DateRange | undefined) {
	const { from, to } = getDateRangeBounds(range);

	return {
		startDate: from?.toISOString(),
		endDate: to?.toISOString(),
	};
}
